import Vue from 'vue';
import Vuex from 'vuex';

import general from './modules/general.js'

import * as actions from './actions.js';

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    modules: {
        general
    }
});